import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IonAvatar } from '@ionic/angular/standalone';

@Component({
  selector: 'app-avatar-or-initials',
  templateUrl: './avatar-or-initials.component.html',
  styleUrls: ['./avatar-or-initials.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IonAvatar]
})
export class AvatarOrInitialsComponent {
  @Input() avatarBase64: string;
  @Input() initials: string;
}
